// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2VCZk","error":"Textarea_error__3fQjH","readonly":"Textarea_readonly__3ufrg","disabled":"Textarea_disabled__1A8AH"};